/**
 * Created by slava on 24.03.17.
 */

const HoseLocation = function (locationConfig, slot) {
    cleverapps.EventEmitter.call(this);

    this.slot = slot;

    this.locationConfig = locationConfig;
    this.locationId = locationConfig.locationId;

    this.stage = this.slot.load("stage") || 0;
    this.progress = this.slot.load("progress") || 0;
};

HoseLocation.prototype = Object.create(cleverapps.EventEmitter.prototype);
HoseLocation.prototype.constructor = HoseLocation;

HoseLocation.prototype.getStage = function () {
    return this.stage;
};

HoseLocation.prototype.setStage = function (stage) {
    this.stage = stage;
    this.slot.save("stage", this.stage);

    cleverapps.user.incProgressCompare();
};

HoseLocation.prototype.getTotalStages = function () {
    const language = cleverapps.config.type === "board" ? cleverapps.settings.language : undefined;

    if (HoseLocation.TOTAL_STAGES_CACHE !== undefined && HoseLocation.TOTAL_STAGES_LANGUAGE === language) {
        return HoseLocation.TOTAL_STAGES_CACHE;
    }

    for (let stageNo = 0; ; ++stageNo) {
        let bundleName = `episode_${stageNo}`;

        if (language !== undefined && language !== "en") {
            bundleName += `_${language}`;
        }

        if (!bundles[bundleName] || bundles[bundleName].meta.debug) {
            HoseLocation.TOTAL_STAGES_CACHE = stageNo;
            HoseLocation.TOTAL_STAGES_LANGUAGE = language;
            break;
        }
    }

    return HoseLocation.TOTAL_STAGES_CACHE;
};

HoseLocation.prototype.getProgress = function () {
    return this.progress;
};

HoseLocation.prototype.changeProgress = function (progress, silent) {
    this.setProgress(this.progress + progress, silent);
};

HoseLocation.prototype.setProgress = function (progress, silent) {
    this.progress = progress;
    this.slot.save("progress", this.progress);

    cleverapps.user.incProgressCompare();

    if (!silent) {
        this.onUpdateProgress();
    }
};

HoseLocation.prototype.onUpdateProgress = function () {
    this.trigger("updateProgress");
};

HoseLocation.prototype.isLocationCompleted = function () {
    return this.getStage() >= this.getTotalStages();
};

HoseLocation.prototype.isCompleted = function () {
    return this.progress >= HoseLocation.LEVELS_PER_LOCATION;
};

HoseLocation.prototype.canMoveNext = function () {
    return this.stage < this.getTotalStages();
};

HoseLocation.prototype.gamePlayed = function (game) {
    if (game.outcome !== GameBase.OUTCOME_VICTORY) {
        return;
    }

    if (this.getStage() < this.getTotalStages()) {
        this.setProgress(this.progress + 1);
    }

    cleverapps.user.incPhysicalLevel();
};

HoseLocation.prototype.getBackgroundBundle = function () {
    if (!bundles.main_background_vertical || !bundles.main_background_horizontal) {
        return;
    }
    return cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL ? "main_background_vertical" : "main_background_horizontal";
};

HoseLocation.prototype.moveNextStage = function () {
    cleverapps.focusManager.display({
        focus: "moveNextStage",
        actions: [
            (f) => {
                new FinishEpisodeWindow(this.getStage());

                cleverapps.focusManager.onceNoWindowsListener = f;
            },
            (f) => {
                this.setProgress(0);
                this.setStage(this.getStage() + 1);

                f();
            },
            (f) => {
                const scene = cleverapps.Scenes.GetSceneComponent(HoseSceneComponent);

                let floatPage = this.getStage();
                if (!this.canMoveNext()) {
                    floatPage += 1.4;
                }

                scene.gotoNextStage(f, floatPage);
            },
            (f) => {
                cleverapps.Plot.onStartEpisode(f, {
                    episodeNo: this.getStage()
                });
            }
        ]
    });
};

HoseLocation.GetMainScene = function () {
    return bundles.main.jsons.hosescene_prefab_json;
};

HoseLocation.LEVELS_PER_LOCATION = 15;
